
    import Vue from "vue";
    import { Prop, Watch, Component } from "vue-property-decorator";

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop( { type: Array, default: [] } )
        public Items: Array<{ Nombre: string; Id: any; }>;

        @Prop( { default: 'Nombre' })
        public Nombre: string;

        @Prop()
        public value: number;
        @Watch( 'value', { immediate: true } )
        onIndex()
        {
            if ( this.value >= 0 && this.SelectedIndex !== this.value )
                this.SelectedItem = this.Items[this.value];
        }

        @Prop( { type: String } )
        public Titulo: string;

        public selectedItem: { Nombre: string; Id: any; } = null;
        public get SelectedItem(): { Nombre: string; Id: any; }
        {
            return this.selectedItem;
        }
        public set SelectedItem( x: { Nombre: string; Id: any; } )
        {
            this.selectedItem = x;
            this.$emit( 'input', this.SelectedIndex );
            this.$emit( 'change', this.SelectedIndex );
        }



        public get SelectedIndex(): number
        {
            if ( this.selectedItem )
                return this.Items.findIndex( x => x.Id == this.selectedItem.Id );
            return -1;
        }

    }
